import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { userSignUp } from "../services/signService";

export default function UserSignAll() {
  const navigate = useNavigate();

  // 회원 정보
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    passwordConfirm: "",
    name: "",
    birth: "",
    phone: "",
    address: "",
    email: "",
  });

  // 보호대상자 정보
  const [protectedData, setProtectedData] = useState({
    name: "",
    birth: "",
  });

  // 전화번호 자동 포맷
  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/[^0-9]/g, "");
    let formatted = cleaned;
    if (cleaned.length < 4) {
      formatted = cleaned;
    } else if (cleaned.length < 7) {
      formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    } else if (cleaned.length < 11) {
      formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else {
      formatted = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7, 11)}`;
    }
    return formatted;
  };

  // 회원정보 입력
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      setFormData({ ...formData, [name]: formatPhoneNumber(value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // 보호대상자 입력
  const handleProtectedChange = (e) => {
    const { name, value } = e.target;
    setProtectedData({ ...protectedData, [name]: value.trim() });
  };

  // 약관 이동
  const handlePrivacy = (e) => {
    e.preventDefault();
    window.location.href = "/privacy.html";
  };

  const handleTerms = (e) => {
    e.preventDefault();
    window.location.href = "/terms.html";
  };

  // 가입하기
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username || !formData.password || !formData.passwordConfirm) {
      alert("아이디와 비밀번호를 입력해주세요.");
      return;
    }
    if (formData.password !== formData.passwordConfirm) {
      alert("비밀번호가 일치하지 않습니다.");
      return;
    }
    if (!protectedData.name || !protectedData.birth) {
      alert("보호대상자 정보를 입력해주세요.");
      return;
    }

    const requestData = {
      username: formData.username,
      password: formData.password,
      name: formData.name,
      email: formData.email,
      birth: formData.birth,
      address: formData.address,
      phone: formData.phone,
      protect_name: protectedData.name,
      protect_birth: protectedData.birth,
    };

    console.log("최종 전송 데이터:", requestData);

    try {
      const response = await userSignUp(requestData);
      if (response.success === false) {
        alert(response.message || "회원가입 실패. 다시 시도해주세요.");
      } else {
        alert("회원가입이 완료되었습니다!");
        navigate("/login");
      }
    } catch (error) {
      alert("회원가입 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="user_sign">
      <p className="title">
        <img src="/media/logo.png" alt="곡성 스마트 안전지도" />
      </p>
      <h2>회원가입</h2>

      <form onSubmit={handleSubmit}>
        {/* 회원 정보 입력 */}
        <label htmlFor="username">아이디</label>
        <p className="inpubox"><input type="text" id="username" name="username" placeholder="아이디를 입력해주세요" onChange={handleChange} required /> <span className="red">※</span></p>

        <label htmlFor="password">비밀번호</label>
        <p className="inpubox"><input type="password" id="password" name="password" placeholder="비밀번호를 입력해주세요" onChange={handleChange} required /> <span className="red">※</span></p>

        <label htmlFor="passwordConfirm">비밀번호 확인</label>
        <p className="inpubox"><input type="password" id="passwordConfirm" name="passwordConfirm" placeholder="비밀번호를 다시 입력해주세요" onChange={handleChange} required /> <span className="red">※</span></p>

        <label htmlFor="name">이름</label>
        <p className="inpubox"><input type="text" id="name" name="name" placeholder="이름을 입력해주세요" onChange={handleChange} required /> <span className="red">※</span></p>

        <label htmlFor="phone">전화번호</label>
        <p className="inpubox"><input type="text" id="phone" name="phone" onChange={handleChange} value={formData.phone} maxLength={13} placeholder="전화번호를 입력해주세요" required /> <span className="red">※</span></p>

        {/*<label htmlFor="birth">생년월일</label>
        <p className="inpubox"><input type="date" id="birth" name="birth" placeholder="" onChange={handleChange} required /> <span className="red">※</span></p>*/}

        <label htmlFor="address">주소</label>
        <p className="inpubox"><input type="text" id="address" name="address" placeholder="주소를 입력해주세요" onChange={handleChange} required /> <span className="red">※</span></p>

        <label htmlFor="email">이메일</label>
        <input type="email" id="email" name="email" placeholder="이메일을 입력해주세요" onChange={handleChange} />

        {/* 보호대상자 정보 입력 */}
        <h2 className="h2tit">보호대상자 정보</h2>
        <label htmlFor="protect_name">보호대상자 이름</label>
        <p className="inpubox"><input type="text" id="protect_name" name="name" placeholder='보호대상자의 이름을 입력해주세요.' value={protectedData.name} onChange={handleProtectedChange} required /><span className="red">※</span></p>

        {/*<label htmlFor="protect_birth">보호대상자 생년월일</label>
        <p className="inpubox"><input type="date" id="protect_birth" name="birth" value={protectedData.birth} onChange={handleProtectedChange} required /> <span className="red">※</span></p>*/}

        <button type="submit" className="sign_btn">가입하기</button>
        <div className="bottombtnwrp">
          <button className="terms_btn" onClick={handleTerms}>이용약관</button>
          <button className="privacy_btn" onClick={handlePrivacy}>개인정보처리방침</button>
        </div>
        
        
      </form>
    </div>
  );
}
